import type { ReactNode } from 'react';

import {
  ColleagueIcon,
  FacebookIcon,
  LinkedinIcon,
  XTwitterIcon,
  YoutubeIcon,
} from './icons';
import type { Referral } from './types';

export const REFERRAL_ICONS: Record<Referral, ReactNode> = {
  Colleague: <ColleagueIcon />,
  Facebook: <FacebookIcon />,
  Linkedin: <LinkedinIcon />,
  'X (Twitter)': <XTwitterIcon />,
  Youtube: <YoutubeIcon />,
};
